import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToPricing = () => {
    window.location.href = '/pricing';
  };
  return <section className="relative bg-white dark:bg-[#0C1B26] pt-20 md:pt-24 overflow-hidden" data-id="element-271">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-272">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center max-w-7xl mx-auto" data-id="element-273">
          {/* Left Text Panel */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="bg-[#212C34] rounded-[18px] p-8 md:p-10 lg:p-12 shadow-xl order-2 lg:order-1" data-id="element-274">
            <h1 className="font-bold mb-6 leading-tight text-white text-[clamp(2rem,5vw,3.25rem)] font-heading" data-id="element-275">
              Affordable, Beautiful Websites That Convert
            </h1>
            <p className="text-white/90 mb-8 leading-relaxed text-[clamp(0.9375rem,1.5vw,1.125rem)]" data-id="element-276">
              UK-based web design, e-commerce and SEO built for performance and
              results.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-277">
              <button onClick={scrollToContact} className="w-full sm:w-auto px-8 py-4 bg-[#0DC3DC] text-[#0C1B26] font-bold rounded-full shadow-lg hover:bg-[#0DC3DC]/90 transition-all duration-300 hover:scale-105 min-h-[44px] text-base md:text-lg" aria-label="Get a free quote for your website" data-id="element-278">
                Get a Free Quote
              </button>
              <button onClick={scrollToPricing} className="w-full sm:w-auto px-8 py-4 bg-white text-[#212C34] font-bold rounded-full shadow-lg border border-[#0DC3DC]/40 hover:bg-[#0DC3DC] hover:text-white transition-all duration-300 hover:scale-105 min-h-[44px] text-base md:text-lg" aria-label="View our pricing packages" data-id="element-279">
                View Pricing
              </button>
            </div>
          </motion.div>
          {/* Right Image Panel */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative rounded-2xl overflow-hidden shadow-2xl order-1 lg:order-2 h-[400px] md:h-[500px] lg:h-[600px]" data-id="element-280">
            <div className="absolute inset-0" data-id="element-281">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7h4F7CW9YaQiRNGtBtHmYX/Hero.png" alt="Professional web designers collaborating on mobile app wireframes and UI/UX design layouts - Bright Pixxel Studios UK web design process" className="w-full h-full object-cover" loading="eager" fetchPriority="high" style={{
              objectPosition: 'center center'
            }} data-id="element-282" />
              <div className="absolute inset-0 bg-gradient-to-r from-[rgba(12,27,38,0.12)] to-transparent" data-id="element-283"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}